export default {
	data: () => ({
		rawData: [],
		entries: [],
		itemsPerPage: 6,
	}),
	watch: {
		$route: {
			handler: function () {
				this.getEntry();
			},
			deep: true,
		},
		"$route.query.page": {
			handler: async function () {
				this.splitItemsPerPage();
			},
			deep: true,
		},
	},
	methods: {
		replaceBrokenImage(event) {
			event.target.src = require("@/assets/img/error/no-image.png");
		},
		createAction() {
			this.$router.push({
				name: "admin." + this.$route.name.split(".")[1] + ".create",
			});
		},
		getDateTime(rawData) {
			return (
				rawData.substring(8, 10) +
				"-" +
				rawData.substring(5, 7) +
				"-" +
				rawData.substring(0, 4)
			);
		},
		pushNewsDetail(id) {
			this.$router.push({
				name: "admin.news.detail",
				params: { id: id },
			});
		},
		viewEntry(entry) {
			this.$router.push({
				name: "admin." + this.$route.name.split(".")[1] + ".detail",
				params: { id: entry._id },
			});
		},
		editEntry(entry) {
			this.$router.push({
				name: "admin." + this.$route.name.split(".")[1] + ".edit",
				params: { id: entry._id },
			});
		},
		splitItemsPerPage() {
			let currentPage = this.$route.query.page ? this.$route.query.page : 1;
			let start_index = (currentPage - 1) * this.itemsPerPage;
			let end_index = start_index + this.itemsPerPage;
			this.entries = this.rawData.slice(start_index, end_index);
		},
	},
	created() {
		this.getEntry();
	},
};
